import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LocationInfo from "./Location";
import Wrapper from "../wrapper/Wrapper";
import ChangeLocation from "./ChangeLocation";
import { ReactReduxContext } from 'react-redux';
import { mobileAppUtil } from '../../util/mobileAppUtil';
import Modal from // ModalNoHeader as Modal
"../modal/Modal";
export var NoLocationModal = function NoLocationModal(props) {
  var results = props.results,
      additionalResults = props.additionalResults,
      toggleChangeModal = props.toggleChangeModal,
      setUserModified = props.setUserModified,
      noLocationShow = props.noLocationShow,
      store = props.store,
      location = props.location,
      onCloseCallback = props.onCloseCallback;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSelection = _useState2[0],
      setSelection = _useState2[1]; // console.log('Check no location show:', noLocationShow);


  useEffect(function () {
    if (location) {
      setSelection(true);
    } else {
      setSelection(false);
    }
  }, [location]);
  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(Modal, {
      show: noLocationShow,
      className: "cb-location-none cb-location-modal",
      size: "lg",
      locationColor: "yellow-200",
      hide: function hide() {
        if (mobileAppUtil.isMobileApp()) {
          // TODO :: Merging in Sprint 15 broke this come back and find out what wrongs
          if (Object.prototype.toString.call(onCloseCallback) == '[object Function]') try {
            onCloseCallback();
          } catch (error) {
            console.error('error in NoLocationModal', error);
          }
          setUserModified(true);
        } else {
          console.log('Test status: ', noLocationShow);
          return setUserModified(true);
        }
      },
      hideCloseButton: true
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "cb-banner__title cb-location-modal__confirmation-heading"
    }, " ", /*#__PURE__*/React.createElement("strong", null, "Let's"), " Eat"), /*#__PURE__*/React.createElement("br", null), Boolean(location) ? /*#__PURE__*/React.createElement("h2", {
      className: "cb-location-modal__confirmation-subheading"
    }, "Please confirm your store") : /*#__PURE__*/React.createElement("h2", {
      className: "cb-location-modal__confirmation-subheading"
    }, "Please select your store")), showSelection && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
      layout: {
        padding: "small"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-location-none__info"
    }, /*#__PURE__*/React.createElement(LocationInfo, {
      store: store,
      changeLocationHandler: function changeLocationHandler() {
        // setUserModified(true)
        setSelection(false);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "cb-location-none__button"
    }, /*#__PURE__*/React.createElement("button", {
      className: "cb-button-secondary",
      onClick: function onClick() {
        // setUserModified(true);
        setSelection(false);
      }
    }, "Select Different Store"), /*#__PURE__*/React.createElement("button", {
      className: "cb-button-primary",
      onClick: function onClick() {
        setUserModified(true);

        if (mobileAppUtil.isMobileApp()) {
          try {
            if (Object.prototype.toString.call(onCloseCallback) == '[object Function]') onCloseCallback();
          } catch (error) {
            console.error('error in NoLocationModal', error);
          }
        }

        return toggleChangeModal();
      }
    }, "Confirm Store"))), !showSelection && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ChangeLocation, {
      store: store,
      changeLocationHandler: toggleChangeModal,
      setStoreHandler: function setStoreHandler() {
        setUserModified(true);
        setSelection(true);
        return toggleChangeModal();
      },
      showCurrent: false,
      results: results,
      additionalResults: additionalResults,
      hideHeader: true
    }))))));
  }.bind(_this));
};